import { cn } from '../utils/cn';

interface TextareaInputProps {
  label: string;
  name: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  error?: string;
  hint?: string;
  required?: boolean;
  disabled?: boolean;
  rows?: number;
  className?: string;
}

export default function TextareaInput({
  label, name, value, onChange, onBlur, placeholder, error, hint, required, disabled, rows = 3, className,
}: TextareaInputProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <label htmlFor={name} className="block text-xs font-medium text-content-secondary">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        className={cn(
          'w-full rounded-lg border px-3 py-2 text-sm text-content-primary bg-surface-card placeholder:text-content-muted outline-none transition-colors resize-none',
          error ? 'border-danger' : 'border-border focus:border-primary focus:ring-1 focus:ring-primary',
          disabled && 'opacity-50 cursor-not-allowed'
        )}
      />
      {error && <p className="text-xs text-danger">{error}</p>}
      {hint && !error && <p className="text-xs text-content-muted">{hint}</p>}
    </div>
  );
}
